import {BASE_URL, endPoints} from './urls';
import fetchClient from './index';
export const selectBillCycle = async (data: any) => {
  try {
    const query = {
      params: data,
    };
    const response = await fetchClient().get(`${BASE_URL}${endPoints.BILLING_CYCLE}`, query);
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
};

export const stripeHandle = async (billingType: any) => {
  try {
    const result = await fetchClient().post(
      `${BASE_URL}${endPoints.STRIPE_REDIRECT_URI}`,
      billingType
    );
    return result;
  } catch (e) {
    console.log('error', e);
  }
};
